import type { Component } from "solid-js";
import { Show } from "solid-js";
import { isNil } from "lodash-es";
import Handlebar from "../../../components/field/Handlebar";
import type { IconName } from "../../../components/icon/Icon";
import Text from "../../../components/text/Text";
import { Checkbox } from "../../../components/checkbox/Checkbox";
import DropIndicator from "./DropIndicator";
import Draggable from "./Draggable";
import { useTranslation } from "../../../state/i18n";
import { DynamicValueIconTile } from "../../../components/icon/IconTile";

export type DraggableListItemProps = {
  id: string;
  label: string;
  icon: IconName;
  iconClasses: string;
  index: number;
  isLast: boolean;
  selected: boolean;
  onSelected: (value: boolean) => void;
};

const DraggableListItem: Component<DraggableListItemProps> = (props) => {
  const { t } = useTranslation();
  let dragHandle!: HTMLDivElement;

  return (
    <Draggable
      data={{
        type: "COLUMN",
        id: props.id,
        index: props.index,
      }}
      dragHandle={dragHandle}
      isLast={props.isLast}
      preview={() => (
        <div class="flex w-88 items-center gap-2.5 rounded-sm border border-default bg-surface-default py-2.5 pr-2 pl-3 shadow-elevation-light-3">
          <Handlebar />
          <Text class="text-base-regular text-primary" text={props.label} truncate />
        </div>
      )}
    >
      {(state) => (
        <button
          class="flex w-full items-center gap-2.5 rounded-sm py-2.5 pr-2 pl-3 hover:bg-surface-hover"
          classList={{
            "opacity-50": state().type === "is-dragging",
            "bg-surface-active-brand": props.selected,
            "bg-surface-default": !props.selected,
          }}
          onClick={() => props.onSelected(!props.selected)}
        >
          <div class="cursor-grab" ref={dragHandle}>
            <Handlebar expandDragArea />
          </div>

          <DynamicValueIconTile
            size="sm"
            icon={props.icon}
            iconClassList={{
              [props.iconClasses]: true,
            }}
          />

          <Text class="text-base-regular text-primary" text={props.label} truncate />

          <div class="ml-auto">
            <Checkbox
              ariaLabel={
                props.selected
                  ? t(($) => $.CHECKBOX_FIELD_VALUE_TRUE_LABEL)
                  : t(($) => $.CHECKBOX_FIELD_VALUE_FALSE_LABEL)
              }
              checked={props.selected}
              setChecked={() => undefined}
            />
          </div>

          <Show when={state().type === "is-dragging-over" && !isNil(state().closestEdge)}>
            <DropIndicator edge={state().closestEdge!} gap={0} />
          </Show>
        </button>
      )}
    </Draggable>
  );
};

export default DraggableListItem;
